<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.73321 2.13345C3.59674 2.13345 3.46012 2.18543 3.35612 2.2897L2.28946 3.35637C2.08092 3.5649 2.08092 3.90253 2.28946 4.11053L6.17904 8.00012L2.28946 11.8897C2.08092 12.0982 2.08092 12.4359 2.28946 12.6439L3.35612 13.7105C3.56466 13.9191 3.90229 13.9191 4.11029 13.7105L7.99987 9.82095L11.8895 13.7105C12.0975 13.9191 12.4356 13.9191 12.6436 13.7105L13.7103 12.6439C13.9188 12.4353 13.9188 12.0977 13.7103 11.8897L9.82071 8.00012L13.7103 4.11053C13.9188 3.90253 13.9188 3.56437 13.7103 3.35637L12.6436 2.2897C12.4351 2.08117 12.0975 2.08117 11.8895 2.2897L7.99987 6.17928L4.11029 2.2897C4.00602 2.18543 3.86967 2.13345 3.73321 2.13345Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: { type: String, default: '' },
    height: { type: String, default: '' },
    color: { type: String, default: '' },
  },
}
</script>
